import labelConfig from "./functions/label-config.json";
import { BASE_URL } from "./env";
import rawLabelFR from "./functions/rawLabelFR.json";
import rawLabelNL from "./functions/rawLabelNL.json";
import React from "react";

// let initEvent = new Event("init");
const urlParams = new URLSearchParams(window.location.search);
const stepService = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`;
const labelsService = `${BASE_URL}/onboarding-entrepreneur-front/v1/labels/`;
const fetchOptions = {
  credentials: "include",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

const SUPPORTED_LANGUAGES = ["FR", "NL"];

// LANGUAGE
const getLangFromUrl = () =>
  SUPPORTED_LANGUAGES.includes(
    document.location.pathname.split("/")[1].toUpperCase()
  ) && document.location.pathname.split("/")[1].toUpperCase();

const getLanguageFromBackends = async () => {
  const languageEndPoint = `${stepService}/language`;
  const correIDendPoint = `${BASE_URL}/onboarding-entrepreneur-front/v1/payload`;
  const isConfirmationWithCorreID = urlParams.has("correID");
  const CorreID = isConfirmationWithCorreID ? urlParams.get("correID") : false;

  const fetchLanguage = CorreID
    ? await fetch(`${correIDendPoint}/${CorreID}`, fetchOptions)
    : await fetch(languageEndPoint, fetchOptions);

  if (fetchLanguage.ok) {
    const language = CorreID
      ? (await fetchLanguage.json()).language
      : (await fetchLanguage.json()).fieldValue;
    localStorage.setItem("language", language);

    const path = document.location.pathname.split("/");

    if (path[1] !== "nl" && path[1] !== "fr" && CorreID) {
      path.splice(1, 0, language.toLowerCase());
      path.join("/");
      console.log(path.join("/"));
      document.location.pathname = path.join("/");
      console.log(document.location);
    }
  }

  !fetchLanguage.ok && setLanguageToBackend();
};

const setLanguageToBackend = (LANG) => {
  fetch(stepService, {
    ...fetchOptions,
    method: "POST",
    body: JSON.stringify([
      {
        fieldId: "language",
        fieldValue: LANG || "FR",
      },
    ]),
  });
};

const language = () => {
  const langFromUrl = getLangFromUrl();
  localStorage.setItem("language", langFromUrl || "FR");
  langFromUrl && setLanguageToBackend(langFromUrl);
  !langFromUrl && getLanguageFromBackends();
};

// LABLES
const fetchLabels = async () => {
  try {
    const response = await Promise.all(
      SUPPORTED_LANGUAGES.map((lang) => fetch(`${labelsService}${lang}`))
    );

    return (
      response.every((response) => response.ok === true) &&
      (await Promise.all(response.map((res) => res.json())))
    );
  } catch (err) {
    console.log(err);
  }
};

const filterLabels = (arr) =>
  arr.reduce((a, b) => {
    const i = a.findIndex((x) => x.internalKey === b.internalKey);
    if (i < 0) return [...a, b];

    if (i >= 0) {
      const HBInternalField = arr
        .filter((c) => c.internalKey === b.internalKey)
        .filter((d) => d.internalField === "Hello bank");

      const accLabelArray = [...a];
      accLabelArray.splice(i, 1);

      return [...accLabelArray, ...HBInternalField];
    }
  }, []);

const recursiveLabelMapping = (obj, { lang, labels, translations }) => {
  for (var k in obj) {
    if (typeof obj[k] === "object" && obj[k] !== null) {
      recursiveLabelMapping(obj[k], { lang, labels, translations });
    } else {
      const id = obj[k].toString();
      const label = labels[lang];
      const text = label.find((itm) => itm.internalKey === id)?.rawText;
      if (text !== undefined) {
        obj[k] = text;
        translations[lang.toLowerCase()] = {
          ...translations[lang.toLowerCase()],
          ...obj,
        };
      }
    }
  }
};

const mappingTraLabelId = (response) => {
  const LANG = localStorage.getItem("language");
  const res = response;
  // const res = [rawLabelFR, rawLabelNL];
  console.log("res => ", res);
  const FR = filterLabels(res[0]);
  const NL = filterLabels(res[1]);
  const labels = { FR, NL };

  console.log("labels => ", labels);
  const translations = { default: { fr: {}, nl: {} } };

  recursiveLabelMapping(
    { ...labelConfig },
    { lang: LANG, labels, translations: translations.default }
  );

  console.log("translations => ", translations);
  return translations;
};

export const getLabels = async () => {
  console.log("labal init");
  const translations = await mappingTraLabelId(await fetchLabels());
  localStorage.setItem("translations", JSON.stringify(translations));
  return translations;
};

const initHBHE = (() => {
  const init = () => {
    getLabels();
    language();
  };

  init();
})();

export default initHBHE;
